import React from "react";
import UseTable from "../../components/table/useTable";
import { useTranslation } from "react-i18next";
import globalStyles from "../../style/global.js";
import useStyles from "./invoicesStyle";

import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

import ErrorMessage from "../../components/errorMessage/ErrorMessage";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";

import { Box, Typography } from "@mui/material";

import PageTitle from "../../components/pageTitle/PageTitle";
import { getInvoicesData } from "../../redux/reduser/invoices";
function Invoices() {
  const { t } = useTranslation();
  const classes = useStyles();
  const globalClasses = globalStyles();
  const { data, loading, error } = useSelector((state) => state.invoices);


  
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getInvoicesData());
  }, []);

  const columns = [
    { name: t("id") },
    { name: t("customer") },
    { name: t("status") ,
    options: {
      
      customBodyRenderLite: (dataIndex) => {
        return (
          <>
        
              <Box className={classes.statusBox}>
             <Typography  >{data[dataIndex][2]}</Typography>
          </Box>
             
         
           
          </>
        );
      },
    },},
    
    { name: t("date") },
    { name: t("totalAmount") },
  ];

  return (
    <Box className={globalClasses.background}>
    <Box className={globalClasses.page}>
    <Box className={globalClasses.row}>
     <PageTitle title={t("invoices")}/>
   
       
    </Box>
    <Box >
    
      {loading === true ? (
        <div className={globalClasses.center}>
          {" "}
          <CircularProgressBar />{" "}
        </div>
      ) : error == null ? (
        <UseTable
          data={data}
          columns={columns}
          title={t("invoices")}
          selectableRows={true}
        />
      ) : (
        <div className={globalClasses.center}>
          {" "}
          <ErrorMessage title={error} />{" "}
        </div>
      )}
    </Box>
    
    </Box>
    </Box>
  );
}
export default Invoices;
